<template>
  <v-card v-if="grade" id="grade-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="end" no-gutters>

        <v-col cols="12">
          <v-text-field
          class="pt-6"
          v-model="grade.name"
          :rules="[rules.required]"
          :label="$t('name')"
          color="black"
          :counter="maxNameLength"
          :maxlength="maxNameLength"
          ref="gradeName"/>
        </v-col>

        <v-col cols="12">
          <v-text-field
          class="pb-6"
          v-model="grade.code"
          :rules="[rules.required]"
          :label="$t('code')"
          color="black"
          :counter="maxCodeLength"
          :maxlength="maxCodeLength"/>
        </v-col>

        <v-col cols="auto">
          <v-btn id="grade-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
            {{ buttonText }}
          </v-btn>
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import fieldRules from '@/utils/rules.js'

export default {
  name: 'GradeForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propGrade: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propGrade) {
      this.grade = JSON.parse(JSON.stringify(this.propGrade))
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.gradeName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.grade?.gradeId
    },

    title () {
      return this.editing ? this.$t('editGrade') : this.$t('createNewGrade')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.grade.name.length > 0 && this.grade.name.length <= this.maxNameLength &&
             this.grade.code.length > 0 && this.grade.code.length <= this.maxCodeLength
    }
  },

  data: () => ({
    grade: {
      name: '',
      code: ''
    },
    maxNameLength: 32,
    maxCodeLength: 10,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('grade', ['createGrade', 'updateGrade']),

    async submitClicked () {
      if (this.validate() && this.canSubmit) {
        this.editing ? await this.updateGrade(this.grade) : await this.createGrade(this.grade)
        this.$emit('grade-mutated')
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    },

    validate () {
      if (this.grade.name.length <= 0 || this.grade.name.length > this.maxNameLength) {
        this.setSnackError(this.$t('nameIsRequired'))
        return false
      }
      if (this.grade.code.length <= 0 || this.grade.code.length > this.maxCodeLength) {
        this.setSnackError(this.$t('codeIsRequired'))
        return false
      }
      return true
    }
  }
}
</script>
